const state = {
  baseUrl: process.env.VUE_APP_API_BASE_URL,
  pageLoading: false,
};

const actions = {
  startPageLoading: (context) => {
    context.commit("UPDATE_PAGE_LOADING", true);
  },
  stopPageLoading: (context) => {
    context.commit("UPDATE_PAGE_LOADING", false);
  },
};

const mutations = {
  UPDATE_PAGE_LOADING: (state, loading) => {
    state.pageLoading = loading;
  },
};

const getters = {
  baseUrl: (state) => state.baseUrl,
  pageLoading: (state) => state.pageLoading,
};

export default {
  state,
  getters,
  actions,
  mutations,
};
